module.exports = __webpack_public_path__ + "img/emoji_39.60483897.png";